export default "__VITE_ASSET__DyxBPEQN__"